import { Component, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ApAlertService } from 'webcommon/core-ui';

import {
  FcFilterConfigurationFieldType,
  FcGenericFilterModalBaseComponent,
} from '../../generic/index';

@Component({
  providers: [ApAlertService],
  selector: 'fc-generic-filter-modal',
  templateUrl: './fc-generic-list-filter-modal.component.html',
})
export class FcGenericListFilterModalComponent extends FcGenericFilterModalBaseComponent {
  public override baseId = 'fc-generic-filter';

  // Form Controls
  public externalIdControl = new FormControl('');
  public nameControl = new FormControl('');

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    name: this.nameControl,
  });

  constructor(injector: Injector) {
    super(injector);

    this.config.set('ExternalID', { type: FcFilterConfigurationFieldType.Single, control: this.externalIdControl });
    this.config.set('Name', { type: FcFilterConfigurationFieldType.Single, control: this.nameControl });
  }
}
